/* Native H.264 playback, one responsive download, still-first progressive enhancement. */
(function(){
  var video=document.getElementById('pdb-hero-film');
  if(!video)return;
  var stage=video.closest('.film-stage'),button=document.getElementById('film-toggle'),caption=document.getElementById('film-caption');
  var mobile=matchMedia('(max-width:700px)'),reduce=matchMedia('(prefers-reduced-motion:reduce)');
  var manualPause=false,visible=true,failed=false;
  function label(){button.setAttribute('aria-label',failed?'Retry animation':video.ended?'Replay animation':video.paused?'Play animation':'Pause animation');}
  function update(){caption.textContent=video.currentTime<3.5?'Pick your garment':'Make it your own';}
  function play(){
    if(!video.getAttribute('src')){video.src=mobile.matches?video.dataset.mobile:video.dataset.desktop;video.load();}
    video.muted=true;
    try{var result=video.play();if(result&&result.catch)result.catch(function(){label();});}catch(e){label();}
  }
  function still(){video.pause();stage.classList.remove('has-frame','is-playing');caption.textContent='Make it your own';label();}
  button.hidden=false;
  button.addEventListener('click',function(){if(!video.paused){manualPause=true;video.pause();}else{manualPause=false;if(failed){failed=false;video.removeAttribute('src');}play();}});
  video.addEventListener('playing',function(){failed=false;stage.classList.add('is-playing','has-frame');update();label();});
  video.addEventListener('pause',function(){stage.classList.remove('is-playing');label();});
  video.addEventListener('ended',label);
  video.addEventListener('timeupdate',update);
  video.addEventListener('error',function(){failed=true;still();});
  function automatic(){if(!manualPause&&!reduce.matches&&visible&&!document.hidden&&!failed)play();else video.pause();}
  document.addEventListener('visibilitychange',automatic);
  if('IntersectionObserver'in window)new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;automatic();},{threshold:.1}).observe(stage);
  function listen(query,fn){if(query.addEventListener)query.addEventListener('change',fn);else if(query.addListener)query.addListener(fn);}
  listen(reduce,function(){if(reduce.matches)still();else automatic();});
  listen(mobile,function(){var resume=!video.paused;video.pause();video.removeAttribute('src');video.load();stage.classList.remove('has-frame','is-playing');caption.textContent='Make it your own';if(resume)automatic();});
  var connection=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
  if(connection&&connection.saveData)manualPause=true;
  automatic();
}());
